export default __webpack_public_path__ + "static/sass-bde0d387cb999d43df545451958e2320.png";